export enum EnumCommercialRelationActionType {
  Subject = 1,
  Contract,
  Product,
  Trade
}
